import { RistoranteCassaincloud } from "orser-model/RistoranteCassaincloud";
import Fetch from "../script/Fetch";
import servicesProvider from "./ServicesProvider";

export class CassaincloudService {
    async insertRistoranteCassaincloudWithApiKey(ristoranteId: string, apiKey: string) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/apiKey`, {
                method: "POST",
                body: {
                    apiKey: apiKey
                }
            });
        } catch (error: any) {
            throw new Error("Errore durante l'inserimento della configurazione Cassa in Cloud.");
        }
    }

    async getTokenStatus(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/token/status`, {
                method: "GET"
            });
        } catch (error: any) {
            throw new Error("Errore durante la verifica dello stato del token.");
        }
    }


    async getRistoranteCassaInCloud(ristoranteId: string) {
        try {
            const response = await Fetch.doFetch(`/cassaincloud/${ristoranteId}`, {
                method: "GET"
            });
            let result = await response.json();
            return RistoranteCassaincloud.fromJson(result);
        } catch (error: any) {
            return undefined;
        }
    }

    async refreshToken(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/token/refresh`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante il refresh del token.");
        }
    }

    async insertCassaincloudTavoloList(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/tavoloList`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante la sincronizzazione dei tavoli da Cassa in Cloud.");
        }
    }

    async insertCassaincloudMenu(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/menu`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante la sincronizzazione del menu da Cassa in Cloud.", error);
        }
    }

    async processAndInsertSalesByDateRange(ristoranteId: string, startDate: string, endDate: string, isFirst: boolean = false) {
        try {
            return await Fetch.doFetch(`/cassaincloud/${ristoranteId}/sales`, {
                method: "POST",
                body: {
                    startDate: startDate,
                    endDate: endDate,
                    isFirst: isFirst
                }
            });
        } catch (error: any) {
            throw new Error("Errore durante la sincronizzazione delle vendite da Cassa in Cloud.");
        }
    }


}